import React from 'react';
import {useTranslation} from '../../../hook/useTranslation';
import './Intro.scss';
import Intro from '../../intro/Intro';

export default function LayoutIntro() {
    const i18n = useTranslation();
    const translationPath = 'laufbahnentwicklung-pflege';

    return (
        <div className="career-model__intro">
            <h1 className="career-model__intro--title">{i18n.translate(`show.items.${translationPath}.title`)}</h1>
            <Intro text={i18n.translate(`show.items.${translationPath}.links.goto_label`)}
                   uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.goto_link`)}
                   size="lg"/>
        </div>
    );
};
